//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SiloLens
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x32a4Bcd8DEa5E18a12a50584682f8E4B77fFF2DF)
 */
export const siloLensAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_siloRepo',
        internalType: 'contract ISiloRepository',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'DifferentArrayLength' },
  { type: 'error', inputs: [], name: 'InvalidRepository' },
  { type: 'error', inputs: [], name: 'UnsupportedLTVType' },
  { type: 'error', inputs: [], name: 'UserIsZero' },
  { type: 'error', inputs: [], name: 'ZeroAssets' },
  {
    type: 'function',
    inputs: [
      { name: '_assetTotalDeposits', internalType: 'uint256', type: 'uint256' },
      {
        name: '_shareToken',
        internalType: 'contract IShareToken',
        type: 'address',
      },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'balanceOfUnderlying',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAPY',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'borrowShare',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_amount', internalType: 'uint256', type: 'uint256' }],
    name: 'calcFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'calculateBorrowValue',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'calculateCollateralValue',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'collateralBalanceOfUnderlying',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'collateralOnlyDeposits',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'debtBalanceOfUnderlying',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'depositAPY',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_timestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getBorrowAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_timestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getDepositAmount',
    outputs: [
      { name: 'totalUserDeposits', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getModel',
    outputs: [
      {
        name: '',
        internalType: 'contract IInterestRateModel',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserLTV',
    outputs: [{ name: 'userLTV', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserLiquidationThreshold',
    outputs: [
      {
        name: 'liquidationThreshold',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserMaximumLTV',
    outputs: [{ name: 'maximumLTV', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'getUtilization',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'hasPosition',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'inDebt',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_user', internalType: 'address', type: 'address' },
    ],
    name: 'isSolvent',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lensPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'liquidity',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'protocolFees',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'siloRepository',
    outputs: [
      { name: '', internalType: 'contract ISiloRepository', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'totalBorrowAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'totalBorrowAmountWithInterest',
    outputs: [
      { name: '_totalBorrowAmount', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'totalBorrowShare',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'totalDeposits',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'totalDepositsWithInterest',
    outputs: [
      { name: '_totalDeposits', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x32a4Bcd8DEa5E18a12a50584682f8E4B77fFF2DF)
 */
export const siloLensAddress = {
  1: '0x32a4Bcd8DEa5E18a12a50584682f8E4B77fFF2DF',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x32a4Bcd8DEa5E18a12a50584682f8E4B77fFF2DF)
 */
export const siloLensConfig = {
  address: siloLensAddress,
  abi: siloLensAbi,
} as const
